//Please add the language resource
const order = {
  msg:{
  }
};
export default order



// WEBPACK FOOTER //
// ./src/page/report/distribute/lang/order.en.js